/**
 * CUÁNTOS CLIENTES HAY: UN SOLO CRITERIO (#56 del informe del 15-08).
 *
 * «Dashboard: 178 clientes totales. Clientes: 180 CLIENTES. Su propia pestaña: Todos (182)».
 * Tres números para lo mismo, y ninguno mentía: cada pantalla contaba una cosa distinta sin
 * decir cuál.
 *
 *   - 178 es lo que cuenta el servidor en `dashboard-stats`: fichas de cliente, sin el
 *     equipo.
 *   - 182 son las filas que devuelve `/admin/clients?include_incomplete=true`, que añade a
 *     los que se registraron y no llegaron a elegir plan (no tienen ficha) y, desde el
 *     13-08, la ficha del propio miembro del equipo que esté mirando.
 *   - 180 era el subtítulo «CLIENTES», que contaba las filas de la pestaña abierta -- «Sin
 *     entrenador» -- pero se leía como el total.
 *
 * El criterio bueno ya existía y es el del servidor; lo que faltaba era que la tabla contara
 * igual. Aquí vive esa regla. Si algún día cambia, cambia en un sitio.
 *
 * Desde el 19-10 la lista de Clientes y la tarjeta «Clientes» del Dashboard cuentan SOLO
 * LOS ACTIVOS (Francisco): `estaFuera`, de aquí, a través de `lib/filtrosDeClientes.
 * esDeLaLista`. Las cuentas de todas las fichas (`cuentaComoCliente`, `contarClientes`,
 * `contarRegistrosSinTerminar`) se quitaron porque ya no las usaba nadie.
 */

// ¿ESTÁ DENTRO? (19-10: lo necesitan la lista de Clientes y el Gestor de clientes, y vivía
// escrito dentro de la primera). El acceso es el que manda el servidor, la misma regla que
// la puerta de la app (`acceso.activo`), no el `status` de la ficha: hay marcados «activo»
// a los que la app ya no deja entrar. Una fila sin `acceso` (un backend viejo) cae al
// `status`. Fuera van juntos los caducados y los que se registraron sin elegir plan.
export const tieneAcceso = (c) => (c?.acceso ? c.acceso.activo : c?.status === 'activo');
export const estaFuera = (c) => c?.status === 'registro_incompleto' || !c?.plan || !tieneAcceso(c);
